PJQ.views.timecards.TimeCardDetailsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-manage-timecard'),
        subTemplates: {
            lineItems: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard-line-items')
        },
        minWidth: '800px',
        onSave: _.noop(),
        model: null,
        canApprove: false,
        canDelete: false
    },
    events: {
        'click .timecard-save': 'saveClicked',
        'click .timecard-delete': 'deleteClicked',
        'click .timecard-approve': 'approveClicked',
        'keyup .overtime-hours, .regular-hours, .doubletime-hours': 'hoursChanged',
        'click .btn-view-locations': 'viewTimecardLocations',
        'click .btn-manage-production-quantities': 'manageProductionQuantities'
    },
    beforeModalCreated: function () {
        if (this.model != null && (this.options.project == null || this.options.project.id !== this.model.get('project').id)) {
            this.options.project = new PJQ.models.projects.Project(this.model.get('project'));
        }

        let fnFetch = _.bind(function () {
            this.isFetched = true;
            this.render();
        }, this)

        if(this.options.project.id <= 0) {
            this.options.permissions = PJQ.app.session.systemPermissions;
            fnFetch();
        } else if (!this.options.project.isFetched) {
            this.options.project.fetch({
                success: _.bind(function () {
                    this.options.permissions = this.options.project.permissions
                    fnFetch();
                }, this)
            })
        } else {
            this.options.permissions = this.options.project.permissions;
            fnFetch();
        }
    },
    beforeRender: function () {
        if (this.isFetched) {
            this.options.canApprove = this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin');
            this.options.canDelete = this.model.get('approvedOn') == null && this.options.permissions.hasPermission('timeCards.isAdmin');
            this.options.canEdit = this.model.get('approvedOn') == null && this.options.permissions.hasPermission('timeCards.canAdd');
            this.options.canViewQuantities = this.options.permissions.hasPermission('productionQuantities.canView');
            this.options.enableOvertime = this.options.settings.get('enableOvertime');
            this.options.enableDoubletime = this.options.settings.get('enableDoubletime');
            this.options.enableLineItems = this.options.settings.get('enableLineItems');
            this.options.enableClockIn = this.options.settings.get('enableClockIn');
        }
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            settings: this.options.settings,
            canEdit: this.options.canEdit,
            canApprove: this.options.canApprove,
            canDelete: this.options.canDelete,
            canViewQuantities: this.options.canViewQuantities,
            enableOvertime: this.options.enableOvertime,
            enableDoubletime: this.options.enableDoubletime,
            enableLineItems: this.options.enableLineItems,
            enableClockIn: this.options.enableClockIn,
            canViewLocationMap: (this.model.get('latitudeIn') && this.model.get('longitudeIn')) || (this.model.get('latitudeOut') && this.model.get('longitudeOut'))
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'textarea'
            ]
        });

        if (this.options.enableLineItems) {
            this.renderLineItems();
        } else {
            this.$('.regular-hours').focus().select();
        }
        this.renderInputs();
        this.renderTotals();
    },
    renderLineItems: function () {
        new PJQ.views.timecards.LineItemsView({
            el: this.$('.line-items-outer'),
            model: this.model,
            project: this.options.project,
            settings: this.options.settings,
            onLineItemChanged: () => {
                this.renderTotals();
            }
        });
    },
    renderInputs: function () {
        this.$('.regular-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('regularHours')));
        this.$('.overtime-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('overtimeHours')));
        this.$('.doubletime-hours').val(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('doubletimeHours')));
        PJQ.helpers.inputHelpers.inputMaskHours(this.$('.input-hours'));

        if(this.options.enableClockIn) {
            new PJQ.inputs.Datepicker({
                el: this.$('.time-in'),
                isTimeOnly: true,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.model.get('timeIn')
                },
                onChange: (value) => {
                    this.model.set('timeIn', value);
                    this.renderTotals();
                }
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.time-out'),
                isTimeOnly: true,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                    defaultDate: this.model.get('timeOut')
                },
                onChange: (value) => {
                    this.model.set('timeOut', value);
                    this.renderTotals();
                }
            });
        }
    },
    renderTotals: function () {
        if(!this.options.enableClockIn) {
            this.$('.total-regular-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('regularHours')));
        } else {
            let minutes = 0;
            if(this.options.enableLineItems){
                _.each(this.model.lineItems.models, function(lineItem){
                    if(lineItem.get('timeIn') != null && lineItem.get('timeOut') != null) {
                        minutes += PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(lineItem.get('timeOut')), new Date(lineItem.get('timeIn')));
                    }
                });
            }
            else if(this.model.get('timeIn') != null && this.model.get('timeOut') != null){
                minutes = PJQ.helpers.dateHelpers.getDateMinutesDiff(new Date(this.model.get('timeOut')), new Date(this.model.get('timeIn')));
            }
            this.$('.total-regular-hours').text(minutes > 0 ? PJQ.helpers.formatHelpers.minutesToHHMM(minutes) : '00:00');
        }

        this.$('.total-overtime-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('overtimeHours')));
        this.$('.total-doubletime-hours').text(PJQ.helpers.formatHelpers.minutesToHHMM(this.model.get('doubletimeHours')));
    },
    hoursChanged: function (e) {
        let $target = $(e.currentTarget),
            type = $target.data('type'),
            minutes = PJQ.helpers.formatHelpers.minutesFromHHMM($target.val());

        this.model.set(type, minutes);
        this.renderTotals();
    },
    saveClicked: function () {
        this.model.set('lineItems', this.model.lineItems.toJSON());

        if (typeof this.options.onSave === 'function') {
            if (this.options.onSave() !== false) {
                this.removeModal();
            }
        } else {
            this.removeModal();
        }
    },
    approveClicked: function () {
        let isApproved = this.model.get('approvedOn') != null;
        new PJQ.views.modals.YesNo({
            header: "Confirm " + (isApproved ? 'Un-Approval' : 'Approval'),
            body: "Are you sure you want to " + (isApproved ? 'un-approve' : 'approve') + " this Time Card?",
            onYes: _.bind(function () {
                if (this.model.get('approvedOn')) {
                    this.model.set('approvedOn', null);
                    this.$('.timecard-approve').text('Approve');
                    this.render();
                } else {
                    this.model.set('approvedOn', new Date());
                    this.saveClicked();
                }
            }, this)
        });
    },
    deleteClicked: function () {
        new PJQ.views.modals.YesNo({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Time Card?",
            onYes: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete();
                }

                this.removeModal();
            }, this)
        });
    },
    viewTimecardLocations: function () {
        new PJQ.views.timecards.TimeCardLocationMapModal({
            model: this.model
        });
    },
    manageProductionQuantities: function() {
        new PJQ.views.productionQuantities.InstalledQuantitiesAddModal({
            project: this.options.project,
            timeCardId: this.model.id,
            collection: this.model.installedQuantities,
            onSave: (quantities) => {
                this.model.installedQuantities.remove(
                    this.model.installedQuantities.filter((model) => model.isNew() || model.get('delete'))
                );

                this.model.installedQuantities.add(quantities);
            }
        });
    }
});